import React from 'react';

interface IconProps {
  className?: string;
  size?: number;
}

export const TwistiesIcon: React.FC<IconProps> = ({ className, size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    {/* Twisties - winding road from above */}
    <path d="M4 20c0-4 4-4 4-8s4-4 4-8" />
    <path d="M8 20c0-4 4-4 4-8s4-4 4-8" />
    <path d="M20 4l-2 2" />
    <path d="M20 4l-2-1" />
  </svg>
);
